/** @jsx jsx */
import { jsx } from '@emotion/core';
import { React } from 'react';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { keyColors } from '../../../styles/colors';
import DotComponent from '../../ui/DotComponent';
import Slider from './Slider';
import Spacer from '../../ui/Spacer';
import { Container, Row, Column } from '../../../styles/Grid';
import * as styles from './index.styles';
import { Icon } from '../../ui/Icon';
import get from 'lodash/get';

import InputForm from './InputForm';
import { DEFAULT_COUNTRY } from '../../../utils/constants';

const defaultData = {
  Strapline: '',
  Header: '',
  IntroText: '',
  SecondaryHeading: '',
  PhoneNumber: '',
  CarouselImages: [
    // 'https://newstore.ictpvtltd.com/newhomepage/headerslide1.png',
    // 'https://newstore.ictpvtltd.com/newhomepage/headerslide2.png',
    // 'https://newstore.ictpvtltd.com/newhomepage/headerslide3.png',
    // 'https://newstore.ictpvtltd.com/newhomepage/headerslide4.png',
  ],
};
export class HeroWithImageCarousel extends SafePureComponent {
  constructor(props) {
    super(props);
    this.fields = props.rendering.fields;
  }

  safeRender() {
    // console.log('** home hero this.fields >> ', this.fields);
    const PhoneNumberOptions = get(
      this.fields,
      'PhoneNumberOptions',
      defaultData,
    );

    const defaultPhoneValue = get(
      this.fields,
      'DomainCountryISOCode2.value',
      DEFAULT_COUNTRY,
    );

    const submitBtnLabel = get(this.fields, 'CTAText.value', '');
    const phoneRegExp = get(
      this.fields,
      'PhoneNumberValidationRegex.value',
      '',
    );
    const formSuccessMsg = get(this.fields, 'PhoneNumberSuccessMessage', '');
    const formFailMsg = get(this.fields, 'PhoneNumberErrorMessage', '');
    const formSubmitAPI = get(this.fields, 'SubmitNumberAPI', '');
    let CarouselImages = get(this.fields, 'CarouselImages', []);
    const SecondaryHeading = get(this.fields, 'SecondaryHeading', '');
    const Header = get(this.fields, 'Header', '');
    const IntroText = get(this.fields, 'IntroText', '');
    const PhoneNumber = get(this.fields, 'PhoneNumber', '');
    const heading = Header.split('|');

    return (
      <Spacer
        customCss={styles.topcontentsholder}
        backgroundColor={keyColors.white}
        paddingCss={styles.containerPadding}
      >
        <Container className={styles.topcont}>
          <Row css={[styles.c1headerpart]}>
            <Column className="leftsec" cols={{ sm: 6, md: 4, lg: 6 }}>
              <div className="c1-headerpartleft">
                <div className="top_p">
                  <p>{SecondaryHeading}</p>
                </div>
                <h1 css={styles.heading}>
                  <span className="linebreak">{heading[0]}</span>
                  <span>{heading[1]}</span>
                  <DotComponent />
                </h1>
                <div className="description_txt">
                  <p>{IntroText}</p>
                </div>

                <InputForm
                  submitBtnLabel={submitBtnLabel}
                  PhoneNumberOptions={PhoneNumberOptions}
                  defaultPhoneValue={defaultPhoneValue}
                  phoneRegExp={phoneRegExp}
                  formSuccessMsg={formSuccessMsg}
                  formFailMsg={formFailMsg}
                  formSubmitAPI={formSubmitAPI}
                />

                <div className="c1_call_sec">
                  {/* <b>{this.fields.SecondaryHeading}</b> */}
                  <span className="call_no">
                    Or you can call us at
                    <a href={`tel:${PhoneNumber}`}>
                      <Icon name="contact" className="phone-default-icon" />
                      <span className="number">{PhoneNumber}</span>
                    </a>
                  </span>
                </div>
              </div>
            </Column>
            <Column className="rightsec" cols={{ sm: 6, md: 4, lg: 6 }}>
              <Slider slides={CarouselImages} />
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

HeroWithImageCarousel.displayName = 'HeroWithImageCarousel';

export default HeroWithImageCarousel;
